module.exports = __webpack_public_path__ + "static/media/4e021187-7ee0-4740-8de7-56f08a00bde9.09b6fc2b.jpg";